<template>
  <kye-autocomplete
    ref="searchTips"
    class="kye-multiple-dept-dialog-seach-input"
    v-model="form.department"
    clearable
    :id="historyId"
    style="width:368px;"
    :prefix-icon="prefixIcon"
    :trigger-on-focus="false"
    :fetch-suggestions="searchDept"
    placeholder="请输入或选择组织"
    @select="(item) => chooseDepartment(item)"
    @input="changeSearch">
  <span slot-scope="scope" v-html="scope.item.$name"></span>
  </kye-autocomplete>
</template>

<script>
export default {
  props: {
    inputSearchUrl: {
      type: String,
    },
    searchDepartmentParams: Function,
    formatResult: Function,
    historyId: String // 配合输入框的历史记录功能, 实现xPath不能区分节点, 添加指定的historyId确认唯一性
  },
  data () {
    return {
      form: {
        departmentId: '',
        department: ''
      },
      prefixIcon: 'el-icon-search',
    }
  },
  methods: {
    // 2021-11-02 过滤搜索结果
    searchFormatResult (res) {
      const formatResult = this.formatResult
      return formatResult ? formatResult(res) : res
    },
    async searchDept (val, cb) {
      try {
        if (val && val.length > 1) {
          let data = await this.$http(this.inputSearchUrl, this.searchDepartmentParams(val))
          const reg = new RegExp(val, 'gi')
          data.map(item => {
            item.$name = `${item.parentName.replace(reg, value => `<span style="color: #7653D6;">${value}</span>`)},${item.name.replace(reg, value => `<span style="color: #7653D6;">${value}</span>`)}`
          })
          const formatResult = this.searchFormatResult(data)
          cb(formatResult)
        } else {
          const noop = []
          cb(noop)
          this.$refs.searchTips.loading = false
          this.$message.warning('请至少输入2个字符')
          return null
        }
      } catch (error) {
        console.log(error)
      }
    },
    changeSearch (val) {
      if (!val) {
        this.clearDepartment()
      }
    },
    async chooseDepartment (item) {
      if (item) {
        let id = item.id
        this.form.departmentId = id
        this.form.department = item.name
        this.$emit('chooseDepartment', item)
      } else {
        this.clearDepartment()
      }
    },
    clearDepartment () {
      this.form.departmentId = ''
      this.form.department = ''
    }
  }
}
</script>

<style lang="less" scoped>
.kye-multiple-dept-dialog-seach-input {
  margin-bottom: 8px;
  .el-input input {
    border-radius: 4px;
  }
  /deep/ .el-input--prefix .el-input__inner {
    padding-left: 28px !important;
  }
  .el-input input::placeholder {
    padding-left: 18px !important;
  }
  .el-input__prefix {
    top: -1px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-dept-multiple/components/input-search.vue